import { useRef, useCallback } from 'react';

export const useDebouncedCallback = (
  func: (...args: any) => any,
  wait: number,
  leading?: boolean, // if true, the first hit will call the api
) => {
  // Use a ref to store the timeout between renders
  // and prevent changes to it from causing re-renders
  const timeout = useRef<number | undefined>(undefined);
  const isLeading = useRef<boolean>(Boolean(leading));

  return useCallback(
    (...args) => {
      if (isLeading.current) {
        isLeading.current = false;
        func(...args);

        return;
      }

      const later = () => {
        clearTimeout(timeout.current!);
        isLeading.current = Boolean(leading);
        func(...args);
      };

      clearTimeout(timeout.current!);
      timeout.current = window.setTimeout(later, wait);
    },
    [func, wait],
  );
};
